import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';

import { ControlValueAccessor } from './../../../shared/interfaces/forms.setup';

import { IErrors } from '../../molecules/input/errors.interface';
import { IInputAtom } from './input.interface';

export const INPUT_CUSTOM_INPUT_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(() => InputAtomSharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-input-atom',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    providers: [
        INPUT_CUSTOM_INPUT_ACCESSOR
    ]
})
export class InputAtomSharedComponent implements ControlValueAccessor {
    @Input() input: IInputAtom;
    @Input() errors: Array<IErrors> = [];
    // tslint:disable-next-line:no-input-rename
    @Input('value') _value = '';

    constructor(private ref: ChangeDetectorRef) {}

    onChange: any = () => {};
    onTouched: any = () => {};

    get type(): string { return (this.input && this.input.type) ? this.input.type : 'text'; }
    get id(): string { return (this.input && this.input.id) ? this.input.id : ''; }
    get placeholder(): string { return (this.input && this.input.placeholder) ? this.input.placeholder : 'Start Typing'; }

    get value(): any { return this._value; }
    set value(val) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    registerOnChange(fn): void {
        this.onChange = fn;
    }

    writeValue(value): void {
        this.value = value;
        this.ref.markForCheck();
    }

    registerOnTouched(fn): void {
        this.onTouched = fn;
    }

    updateValue(event: KeyboardEvent): void {
        this.value = (event.target as HTMLInputElement).value;
    }
}
